import React from 'react'
import {KTCard, KTCardBody} from '../../../../_websoft/helpers'

const RadniNaloziDashboard = () => {
    return (
        <KTCard>
            <KTCardBody className='py-4'>
                <div className='container-fluid px-0 px-md-3'>
                    {/* Header */}
                    <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 mb-4'>
                        <div>
                            <h2 className='fw-bolder text-gray-900 mb-1'>Radni nalozi</h2>
                            <div className='text-muted'>Odaberi akciju koju želiš izvršiti.</div>
                        </div>
                    </div>

                    {/* Grid */}
                    <div className='row g-4'>
                        {/* Spremi Nalog */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='spremi-nalog'
                                className='card bg-success hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{
                                                width: 56,
                                                height: 56,
                                                background: 'rgba(255,255,255,0.18)',
                                            }}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1'></span>
                                                <span className='path2'></span>
                                                <span className='path3'></span>
                                                <span className='path4'></span>
                                            </i>
                                        </div>

                                        <div>
                                            <div className='text-white fw-bolder fs-2 text-uppercase'>Spremi nalog</div>
                                            <div className='text-white opacity-75 mt-1'>
                                                Dodijeli Websoft šifre i potvrdi stavke.
                                            </div>
                                        </div>
                                    </div>

                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>

                        {/* Isporuci Nalog */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='isporuci-nalog'
                                className='card bg-info hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{
                                                width: 56,
                                                height: 56,
                                                background: 'rgba(255,255,255,0.18)',
                                            }}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1'></span>
                                                <span className='path2'></span>
                                                <span className='path3'></span>
                                                <span className='path4'></span>
                                            </i>
                                        </div>

                                        <div>
                                            <div className='text-white fw-bolder fs-2 text-uppercase'>Isporuči nalog</div>
                                            <div className='text-white opacity-75 mt-1'>
                                                Odaberi stavke i potvrdi isporuku.
                                            </div>
                                        </div>
                                    </div>

                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default RadniNaloziDashboard
